import { postRequest } from "../../../services/RestServices";
import * as urls from "../../api/C4S Decommission - Replacement/url";

export const ViewVehicleListByAddress = async (action, bundleId, crmRefId, addressContactList, partRecommendationRequest, actionType, priority) => {
  try {
    const payload = {
      //action,
      bundleId,
      crmRefId,
      addressContactList,
      ...(partRecommendationRequest ? { partRecommendationRequest } : {}),
      ...(actionType ? { actionType } : {}),
      ...(priority !== undefined && priority !== null ? { priority } : {}),
    };
    const response = await postRequest(urls.WT_VIEW_VEHICLE_LIST_BY_ADDRESS, payload);
    return response;
  } catch (err) {
    return err;
  }
};

export const ViewVehicleListByAddressOnly = async (payload) => {
  try {
    const response = await postRequest(urls.WT_VIEW_VEHICLE_LIST_BY_ADDRESS, payload);
    return response;
  } catch (err) {
    return err;
  }
};

export const postApplyActions = async (payload) => {
  try {
    const response = await postRequest(urls.POST_APPLY_ACTIONS, payload);
    return response;
  } catch (err) {
    return err;
  }
};
